"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_JWT_EXPIRY_MS = exports.SUPPORTED_DID_METHODS = exports.DEFAULT_DID_METHOD = exports.DEFAULT_METRICS_URL = exports.DEFAULT_REGISTRY_URL = void 0;
exports.DEFAULT_REGISTRY_URL = 'https://affinity-registry.staging.affinity-project.org';
exports.DEFAULT_METRICS_URL = 'https://affinity-metrics.staging.affinity-project.org';
exports.DEFAULT_DID_METHOD = 'jolo';
exports.SUPPORTED_DID_METHODS = ['jolo', 'elem'];
exports.DEFAULT_JWT_EXPIRY_MS = 10 * 60 * 1000;
//# sourceMappingURL=_defaultConfig.js.map